/**
 * Default splat selection / mask UI colors (Volugraph).
 * Vivid magenta: uncommon in natural scene albedo (grass, sky, concrete, skin),
 * so highlights rarely blend into splat colors. Readable on both light and dark regions.
 */
export const SELECTION_HIGHLIGHT_RGBA = { r: 217 / 255, g: 70 / 255, b: 1, a: 1 } as const;

/** Brush / lasso / polygon stroke & mask fill (matches shader selectedClr). */
export const SELECTION_MASK_STROKE_HEX = '#d946ff';
/** Slightly softer stroke when path is “closed” (lasso / polygon). */
export const SELECTION_MASK_STROKE_SOFT_HEX = '#ea8cff';
